import moment from 'moment'

export function dateFilter(date: string | undefined, format: string = 'llll'): string {
  if (date === undefined || date === '') {
    return ''
  }
  return moment(date).format(format)
}
